import http from '../../utils/fetch';
export default {
    selectRepPage(query){
        return http({
            url:'/api/swyl/v1/dailyClear/userDailyClearPlanRep/selectPage',
            method: 'post',
            params: query
        });
    },
    //获取某月天数
    getMonthDayList(query){
        return http({
            url:'/api/swyl/v1/dailyClear/userDailyClearPlanRep/getMonthDayList',
            method: 'post',
            params: query
        });
    },
    //批量导出
    downloadBatchExcel(query) {
        return http({
            url: '/api/swyl/v1/dailyClear/userDailyClearPlanRep/newDdownloadRqDetailExcel',
            method: 'post',
            data: query,
            responseType: 'blob',
        });
    },
}